import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AuthService} from '../auth/AuthService';
import {Router} from '@angular/router';
import {iClient} from '../Model/ClientModel';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RulesService {

  private httpOptions: any;
  token:any
  constructor(private httpClient: HttpClient,
              private authService: AuthService,
              private router: Router) {
  }


  ruleRegistration(reqData: any, params?: { clientId: string }): Observable<any> {
    const url = params?.clientId
        ? `${environment.coverageService}rule?clientId=${params.clientId}`
        : `${environment.coverageService}rule`;

    // Make the POST request with the updated URL
    return this.authService.post(url, reqData);;
  }

  getAllRules(params?:any): Observable<any> {
    return this.authService.getP(`${environment.coverageService}rule`, params);
  }

  deleteRule(params?:any): Observable<any> {
    return this.authService.delete(`${environment.coverageService}rule`, params);
  }

  getRulesDetails(params?:any): Observable<any> {
    return this.authService.getP(`${environment.coverageService}rule`, params);
  }

  // getClientRoles(params?:any): Observable<any> {
  //   return this.authService.getP(`${'user-service-dev/user/roles'}`, params);
  // }

  updateRules(body: any, params?:any): Observable<any> {
    return this.authService.put(`${environment.coverageService}rule`,body, params);
  }
  getClientDetails(params?:any): Observable<any> {
    return this.authService.getP(`${environment.coverageService}rule`, params);
  }
}